<template lang="html">
  <div class="form-control-filtered-wrapper">
    <template v-if="isFilteredMode">
      <div class="form-control-filtered">
        <input class="form-control" tabindex="0"  :placeholder="placeholder"  type="text" :value="publicValue" :disabled="disabled" :readonly="true" @click.prevent="onClick"/>
      </div>
      <div class="sub-hint">{{$t('filteredField.hint1')}}
        <template v-if="!disabled">
          {{$t('filteredField.hint2')}}
        </template>
      </div>
    </template>
    <template v-if="!isFilteredMode">
      <slot>
        <input class="form-control" :placeholder="placeholder"  tabindex="0" type="text" :disabled="disabled" :value="value" :readonly="readonly" ref="defaultInput" @input="onInput"/>
      </slot>
    </template>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";

@Component({
  name: "FilteredInputWrapper"
})
export default class FilteredInputWrapper extends Vue{
  @Prop({default: ''})
  value: string | null

  @Prop({default: false})
  disabled: boolean

  @Prop({default: false})
  readonly: boolean

  @Prop({default: false})
  placeholder: string

  onClick() {
    if (!this.disabled)
      this.startEdit();
  }


  get publicValue() {
    if (this.isFilteredMode)
    {
      const regex = new RegExp(/^doc:\d+:.*?:doc:(.*)$/);
      const found = this.value.match(regex);
      if (found) {
        return found[1]
      }
    }
    return this.value;
  }

  onInput(event) {
    this.$emit('input', event.target.value);
  }

  startEdit() {
    const regex = new RegExp(/^doc:\d+:.*?:doc:(.*)$/);
    const found = this.value.match(regex);
    if (found) {
      this.$emit('input', ''/*found[1]*/);
      this.$emit('start-edit');
      this.$nextTick(() => {
        if (this.$refs.defaultInput)
        {
          (this.$refs.defaultInput as any).focus();
        }
      });
    }
    this.$emit('start-edit');
  }

  get isFilteredMode(): boolean {
    const regex = new RegExp(/^doc:\d+:.*?:doc:.*$/);
    return regex.test(this.value);
  }
}
</script>

<style scoped lang="less">
.sub-hint {
  font-size: 70%;
  color: #888888;
  padding: 5px 10px;
}

.form-control-filtered {
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-flow: row;
}
</style>

<style lang="less">
.tarnsfer_form {
  @width: 370px;
  .form-control-filtered-wrapper {
    width: @width;
    .form-control-filtered {
      width: @width;
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "filteredField": {
      "hint1": "Часть данных в этом поле скрыта, но будет применено оригинальное значение.",
      "hint2": "Вы можете отредактировать."
    }
  },
  "en": {
    "filteredField": {
      "hint1": "Some of the data in this field is hidden. The original value will be applied.",
      "hint2": "You can edit this field."
    }
  }
}
</i18n>
